import { AfterLoadEventHandler, CreateOptionsParams, ISpecializedCombo, useCombo } from "@hooks/useCombo";
import { MenuItem } from "@material-ui/core";
import { useVendedorService } from "@services/VendedorService";
import { useThemeColor } from "@themes/Colors";
import { IEnum, KeyOfEnum } from "@utils/TypeHelpers";
import React from "react";

export enum EnumVendedorStatus {
    None = 0,
    Ativo = 1,
    Inativo = 2
}

export interface IVendedor {
    vendedorId: number
    nome: string
    cpf: string
    telefone: string
    status: EnumVendedorStatus
    statusDescription: string
}

export type IComboVendedor = ISpecializedCombo<IVendedor>;

export function useVendedorCombo () : IComboVendedor {
    const combo = useCombo<IVendedor>();

    const vendedorService = useVendedorService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((vendedor, index) => {
            return <MenuItem key={index} value={vendedor.vendedorId}>{params?.prefix}{vendedor.nome}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback((afterLoad?: AfterLoadEventHandler<IVendedor>) => {
        combo.load(vendedorService.listarAtivos, afterLoad)
    }, [combo, vendedorService.listarAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}

export type IComboVendedorStatus = ISpecializedCombo<IEnum<EnumVendedorStatus>>;

export function useVendedorStatusCombo () : IComboVendedorStatus {
    const combo = useCombo<IEnum<EnumVendedorStatus>>();

    const vendedorService = useVendedorService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((enumerator, index) => {
            return <MenuItem key={index} value={enumerator.value}>{params?.prefix}{enumerator.description}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback((afterLoad?: AfterLoadEventHandler<IEnum<EnumVendedorStatus>>) => {
        combo.load(vendedorService.listarStatus, afterLoad)
    }, [combo, vendedorService.listarStatus]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}

export function useVendedorStatusColor () {
    const themeColor = useThemeColor();

    const map : KeyOfEnum<EnumVendedorStatus, string> = React.useMemo(() => ({
        [EnumVendedorStatus.None]: "",
        [EnumVendedorStatus.Ativo]: themeColor.status.verde,
        [EnumVendedorStatus.Inativo]: themeColor.status.cinza,
    }), [themeColor.status.cinza, themeColor.status.verde]);

    return React.useMemo(() => map, [map]);
}